import { useDraggedData } from '../dnd';
import { isToken } from './types';
export function useDraggedToken() {
    const data = useDraggedData();
    if (!isToken(data?.data)) {
        return null;
    }
    return data.data.data;
}
//# sourceMappingURL=useDraggedToken.js.map